import React, { ReactElement, ReactNode } from "react"

import ButtonLink from "@/components/design-system/Button/ButtonLink"
import TextH4 from "@/components/design-system/Text/TextH4"

import "./ErrorPage.less"

export interface ErrorPageProps {
  title: ReactNode
  subtitle?: ReactNode
  children?: ReactNode
  returnUrl?: string
  returnText?: string
}

export default function ErrorPage({
  title,
  subtitle,
  children,
  returnUrl = "/",
  returnText = "Return home",
}: ErrorPageProps): ReactElement {
  return (
    <div className="ErrorPage">
      <div className="ErrorPage__card">
        <TextH4 className="ErrorPage__card-title">{title}</TextH4>

        {subtitle ? <div className="ErrorPage__card-subtitle">{subtitle}</div> : null}

        {getContent()}
      </div>
    </div>
  )

  function getContent() {
    if (children) {
      return children
    }

    if (!returnUrl || !returnText) {
      return null
    }

    return (
      <ButtonLink type="primary" className="thick" href={returnUrl}>
        {returnText}
      </ButtonLink>
    )
  }
}
